<template>
    <div class="Partners">
        <h1>
            <span class="title">Partners</span>
            <span class="subtitle">合作学校</span>
        </h1>
        <div class="marquee-partners">
            <Vue3Marquee :pause-on-hover="false" :clone="false" :duration="3 * schools.length">
                <div class="card-partners" v-for="school in schools" :key="avatar">
                    <div>
                        <img :src="require('../assets/images/Partners/schools/' + school.file)" :alt="school.alt" :draggable="false">
                    </div>
                    <p>
                        {{ school.text }}
                    </p>
                </div>
            </Vue3Marquee>
        </div>
    </div>
</template>
<script>
import { Vue3Marquee } from 'vue3-marquee'

import { ref, nextTick } from 'vue';

export default {
    components: {
        Vue3Marquee,
    },
    mounted() {
        nextTick(() => {
            this.updateDimensions();
            window.addEventListener('resize', this.updateDimensions);
        });
    },
    data() {
        const schoolList = [
            {alt: "北京师范大学附属实验中学", text: "北京师范大学\n附属实验中学", file: "北京师范大学附属实验中学.png"},
            {alt: "上海市市西中学", text: "上海市市西中学", file: "上海市市西中学.png"},
            {alt: "上海交通大学附属中学嘉定分校", text: "上海交通大学\n附属中学嘉定分校", file: "上海交通大学附属中学嘉定分校.png"},
            {alt: "上海不列颠英国外籍人员子女学校", text: "上海不列颠英国\n外籍人员子女学校", file: "上海不列颠英国外籍人员子女学校.svg"},
            {alt: "德威国际学校", text: "德威国际学校", file: "德威国际学校.svg"},
            {alt: "上海市民办平和学校", text: "上海市\n民办平和学校", file: "上海市民办平和学校.png"},
            {alt: "包玉刚实验学校", text: "包玉刚实验学校", file: "包玉刚实验学校.png"},
            {alt: "上海耀中外籍人员子女学校", text: "上海耀中\n外籍人员子女学校", file: "上海耀中外籍人员子女学校.png"},
            {alt: "上海大学附属中学", text: "上海大学附属中学", file: "上海大学附属中学.png"},
            {alt: "江苏省苏州中学", text: "江苏省苏州中学", file: "江苏省苏州中学.png"},
            {alt: "南京河西外国语学校", text: "南京河西\n外国语学校", file: "南京河西外国语学校.png"},
            {alt: "上海市大众工业学校", text: "上海市\n大众工业学校", file: "上海市大众工业学校.png"},
            {alt: "上海市华东模范中学", text: "上海市\n华东模范中学", file: "上海市华东模范中学.png"},
            {alt: "同济大学附属实验中学", text: "同济大学\n附属实验中学", file: "同济大学附属实验中学.png"},
            {alt: "同济大学附属七一中学", text: "同济大学\n附属七一中学", file: "同济大学附属七一中学.png"},
            {alt: "上海市市西初级中学", text: "上海市\n市西初级中学", file: "上海市市西初级中学.png"},
            {alt: "上海浦东新区民办惠立学校", text: "上海浦东新区\n民办惠立学校", file: "上海浦东新区民办惠立学校.svg"}
        ];
        const schools = schoolList;
        const maxWidth = ref(window.innerWidth)
        const maxHeight = ref(window.innerHeight)
        const maxDimension = 0;
        const cloneTimes = 1;
        return {
            schoolList,
            schools,
            maxWidth,
            maxHeight,
            maxDimension,
            cloneTimes,
        };
    },
    methods: {
        getClassPropertyInPx(className, propertyName) {
            // 尝试获取页面中第一个具有该类的元素
            let el = document.querySelector('.' + className)
            // 如果没有找到，则创建一个临时元素（注意：这种方法获取到的值可能受到父元素样式影响）
            if (!el) {
                el = document.createElement('div')
                el.className = className
                el.id = 'temp-' + className
                // 为确保计算结果准确，可以临时将该元素设置为 display: inline-block
                el.style.display = 'none'
                document.body.appendChild(el)
            }
            const computedStyle = window.getComputedStyle(el)
            // 得到的宽度一般是一个字符串，形如 "320px"
            const valueInPx = computedStyle.getPropertyValue(propertyName)
            // 如果是临时创建的，则移除
            if (el.id === 'temp-' + className) {
                document.body.removeChild(el)
            }
            return valueInPx
        },
        updateDimensions() {
            const threshold = 50;  // 宽度额外阈值，px
            // console.log('resize');
            if (window.innerWidth > this.maxWidth) {
                this.maxWidth = window.innerWidth;
            }
            if (window.innerHeight > this.maxHeight) {
                this.maxHeight = window.innerHeight;
            }
            if (this.maxDimension !== Math.max(this.maxWidth, this.maxHeight)) {
                this.maxDimension = Math.max(this.maxWidth, this.maxHeight);
                // console.log(this.maxDimension,this.maxWidth, this.maxHeight);
                const width = parseFloat(this.getClassPropertyInPx('card-partners', 'width'));
                // console.log(width);
                const margin = parseFloat(this.getClassPropertyInPx('card-partners', 'margin-left'));
                // console.log(margin);
                const totalLength = (width + margin * 2) * this.schoolList.length;
                const nowLength = totalLength * this.cloneTimes;
                if (nowLength < this.maxDimension + threshold) {
                    const oldCloneTimes = this.cloneTimes;
                    this.cloneTimes = Math.ceil((this.maxDimension + threshold) / totalLength);
                    // console.log(this.cloneTimes);
                    for (let i = 0; i < this.cloneTimes - oldCloneTimes; i++) {
                        this.schools.push(...this.schoolList);
                    }
                    // console.log(this.schools.length);
                }
                // console.log(totalLength, nowLength, this.cloneTimes, this.schools.length);
            }
        },
    },
};

// 不响应页面内拖拽图片
document.addEventListener('dragstart', function (event) {
    if (event.target.tagName === 'IMG') {
        event.dataTransfer.effectAllowed = 'none'; // 设置为“禁止”拖拽
        //   event.dataTransfer.setData('text/plain', null); // 防止默认拖拽行为
    }
});
</script>

<!--
.card-partners > div > img{
    max-width: 100%;
    width: auto;
    height: calc(10vmin * var(--scale-factor));
    object-fit: contain;
    margin: 0;
}

.card-partners > div{
    width: calc(14vmin * var(--scale-factor));
    height: calc(10vmin * var(--scale-factor));
    margin: calc(1vmin * var(--scale-factor));
}

.card-partners > p {
    margin: 0;
    font-size: calc(1.85vmin * var(--scale-factor));
    font-family: 'FangYuan';
    font-weight: normal;
    line-height: 1.2;
    /* 允许自动换行 */
    word-wrap: break-word;
    max-height: 100%; /* 限制文本区域最大高度 */
    height: 100%;
    text-align: center;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
    /* text-overflow: ellipsis; */
    /* white-space: nowrap; */
}

.card-partners {
    width: calc(16vmin * var(--scale-factor));
    height: calc(16vmin * var(--scale-factor));
    align-items: center;
    background-color: #f1f1f1;
    border-radius: 3%;
    box-shadow: 0 calc(0.4vmin * var(--scale-factor)) calc(0.8vmin * var(--scale-factor)) #0003;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: calc(0.4vmin * var(--scale-factor)) calc(1vmin * var(--scale-factor));
    padding: calc(0.5vmin * var(--scale-factor));
    overflow: hidden;
    position: relative;
    /* box-shadow: 1vw 1vw 0 0 rgba(0, 0, 255, 0.2); */
}

.marquee-partners {
    margin: 3vw 0vw;
    /* height: 18vmin; */
    /* overflow: hidden; */
    --scale-factor: 1.25; /* 定义全局缩放比例 */
}

@media screen and (max-height: 500px) {
    .card-partners > div > img{
        height: 60px;
    }

    .card-partners > div{
        width: 84px;
        height: 60px;
        margin: 6px;
    }

    .card-partners > p {
        font-size: 11.1px;
    }

    .card-partners {
        width: 96px;
        height: 96px;
        padding: 3px;
    }
}
-->

<style>
.card-partners > div > img{
    max-width: 100%;
    width: auto;
    height: 12vmin;
    object-fit: contain;
    margin: 0;
}

.card-partners > div{
    width: 18vmin;
    height: 12vmin;
    margin: 1vmin;
}

.card-partners > p {
    margin: 0;
    font-size: 2.5vmin;
    font-family: 'FangYuan';
    font-weight: normal;
    line-height: 1.2;
    word-wrap: break-word;
    height: 6vmin;
    width: 100%;
    text-align: center;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: pre-wrap;
}

.card-partners {
    width: 20vmin;
    height: 20vmin;
    align-items: center;
    background-color: #f1f1f1;
    border-radius: 3%;
    box-shadow: 0 0.5vmin 1vmin #0003;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 0.5vmin 1vmin;
    padding: 1vmin;
    overflow: hidden;
    position: relative;
    /* box-shadow: 1vmin 1vmin 0 0 rgba(0, 0, 255, 0.2); */
}

.marquee-partners {
    margin: 3vw 0vw;
}

/* 小屏竖屏适配 */
@media screen and ((max-height: 500px) or (max-width: 500px)) {
    .card-partners > div > img{
        height: 60px;
    }

    .card-partners > div{
        width: 90px;
        height: 60px;
        margin: 5px;
    }

    .card-partners > p {
        font-size: 12.5px;
        height: 30px;
    }

    .card-partners {
        width: 100px;
        height: 100px;
        box-shadow: 0 2.5px 5px #0003;
        margin: 2.5px 5px;
        padding: 5px;
    }
}

.Partners .title {
    font-family: 'Regular';
    font-size: 3.5vmin;
    margin-top: 3vw;
    display: block;
}

.Partners .subtitle {
    font-family: 'FangYuan';
    font-size: 3vmin;
    font-weight: normal;
    letter-spacing: 0.3em;
    display: block;
}

.Partners {
    color: #513890;
    margin: 6vw 0vw;
}
</style>
